import React from 'react';
import getMatchingVariants from './getMatchingVariants'
import formatSizeNames from '../../../../scripts/utils/formatSizeNames';

type Props = {
  selectedOptions: Array<string>;
  product: any;
  stockMap: Record<string, string>;
  onChange: (updatedOptions: Array<string>) => void;
};


const Options: React.FunctionComponent<Props> = ({
  selectedOptions,
  product,
  onChange,
  stockMap
}: Props) => {

  if (!product) {
    return <></>;
  }
  const update = (index: number, value: string) => () => {
    const updatedOptions = [...selectedOptions];
    updatedOptions[index] = value;
    return onChange(updatedOptions);
  }
  return (
    <div className="quick-add-opts">
      {product.options.map(({ name, values, position }) => (
        <div className="quick-add-opt-group" key={position}>
          <h4 className={`quick-add-opt-title ${product.options.length === 1 ? 'single-option' : '' }` } style={{ fontWeight: 'bold' }}>{name}</h4>
          <ul className="quick-add-opt-list size-select-wrapper">
            {values.map((value, i) => {
              const possibleOptions = [...selectedOptions];
              possibleOptions.splice(position - 1, 1, value);
              const matchingVariants = getMatchingVariants(possibleOptions, product.variants)
              const matchingVariant = matchingVariants.length === 1 ? matchingVariants[0] : null
              const lowStock = Boolean(matchingVariant && stockMap && stockMap[matchingVariant.id] && stockMap[matchingVariant.id] === 'low');
              return (
                <li
                  className={`size-selector quick-add-opt-val${
                    selectedOptions[position - 1] === value ? ' selected' : ''
                  }${
                    matchingVariants.length > 0 ? ' valid' : ''
                  }${
                    matchingVariant && !matchingVariant.available ? ' oos' : ''
                  }`}
                  {...matchingVariants.length > 1 || matchingVariant.available ? {} : { 'data-unavailable': true }}
                  {...lowStock ?  { 'data-low-stock': true } : {}}
                  key={i}>  
                  <input
                    className="visually-hidden"
                    disabled={matchingVariants.length < 1 || (matchingVariant && !matchingVariant.available)}
                    name={`option-${position}`}
                    id={`option-${position}-value-${i}`}
                    checked={selectedOptions[position - 1] === value}
                    onChange={update(position - 1, value)}
                    type="radio"
                    value={value}
                  />
                  <label
                    htmlFor={`option-${position}-value-${i}`}
                  >{formatSizeNames(value, null, null)}</label>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Options
